import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, DatePicker, Form } from 'antd';
import { useState } from 'react';
import './FormDatePicker.scss';
export const FormDatePicker = ({ name, label, isRequired = false, placeholder = '', disabled = false, readOnly = false, rules = [], hidden = false, isRow = false, className = '', col = 24, responsive, format = 'DD/MM/YYYY', minDate, maxDate, ...props }) => {
    const validationRules = [
        ...(isRequired ? [{ required: true, message: `Vui lòng chọn ${label?.toLowerCase() || 'ngày'}!` }] : []),
        ...rules
    ];
    const colProps = responsive ?? { xs: col, sm: col, md: col, lg: col, xl: col, xxl: col };
    const [openState, setOpenState] = useState(undefined);
    const [isRightClicking, setIsRightClicking] = useState(false);
    const [allowCalendarOpen, setAllowCalendarOpen] = useState(false);
    // extract possible open/onOpenChange passed in props to avoid clobbering them
    const { open: openProp, onOpenChange: onOpenChangeProp, ...rest } = props;
    const disabledDate = (current) => {
        if (!current)
            return false;
        if (minDate && current.isBefore(minDate, 'day'))
            return true;
        if (maxDate && current.isAfter(maxDate, 'day'))
            return true;
        return false;
    };
    const handleOpenChange = (isOpen) => {
        if (isRightClicking && isOpen) {
            setOpenState(false);
            onOpenChangeProp?.(false);
        }
        else {
            setOpenState(isOpen);
            onOpenChangeProp?.(isOpen);
        }
    };
    const handleClickCapture = (e) => {
        if (e.button === 2) {
            e.stopPropagation();
            if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
                e.nativeEvent.stopImmediatePropagation();
            }
            e.preventDefault();
        }
    };
    const handleMouseDown = (e) => {
        const target = e.target;
        const isClickingOnInput = target.closest('.ant-picker-input') || target.closest('.ant-picker');
        if (e.button === 0 && isClickingOnInput) {
            setIsRightClicking(false);
            setAllowCalendarOpen(true);
            const currentOpen = openProp !== undefined ? openProp : openState;
            const newOpen = !currentOpen;
            setOpenState(newOpen);
            onOpenChangeProp?.(newOpen);
        }
        else if (e.button === 2) {
            setIsRightClicking(true);
            setAllowCalendarOpen(false);
            setOpenState(false);
            onOpenChangeProp?.(false);
            setTimeout(() => setIsRightClicking(false), 200);
        }
    };
    const renderDatePicker = () => (_jsx(DatePicker, { ...rest, format: format, placeholder: disabled || readOnly ? ' ' : placeholder || `Chọn ngày...`, disabled: disabled || readOnly || isRightClicking, style: { width: '100%' }, disabledDate: disabledDate, inputReadOnly: readOnly, open: allowCalendarOpen && !readOnly ? (openProp !== undefined ? openProp : openState) : false, popupClassName: isRightClicking && !allowCalendarOpen ? 'hidden-calendar-popup' : '', onOpenChange: handleOpenChange, ...{
            onClickCapture: handleClickCapture,
            onMouseDown: handleMouseDown
        } }));
    const renderRow = () => (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [label && (_jsxs("label", { style: {
                    minWidth: '20%',
                    fontWeight: 500,
                    marginBottom: 0,
                    whiteSpace: 'nowrap'
                }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] })), renderDatePicker()] }));
    return (_jsx(Col, { ...colProps, children: name ? (_jsx(Form.Item, { label: isRow ? undefined : label, name: name, rules: validationRules, hidden: hidden, className: `${className} ${readOnly ? 'borderless-datepicker' : ''}`, children: isRow ? renderRow() : renderDatePicker() })) : (_jsx("div", { hidden: hidden, className: `${className} ${readOnly ? 'borderless-datepicker' : ''}`, children: isRow ? (renderRow()) : (_jsxs(_Fragment, { children: [label && (_jsxs("label", { style: {
                            display: 'block',
                            fontWeight: 600,
                            fontSize: 13,
                            marginBottom: isRow ? 0 : 10,
                            whiteSpace: 'nowrap'
                        }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] })), renderDatePicker()] })) })) }));
};
